import React from 'react';

export const KOFlagArt: React.FC = () => (
  <>
    <circle cx="10" cy="10" r="8.88889" fill="#F2F0F2" />
    {/* Taegeuk: blue base with the red curl on top */}
    <circle cx="10" cy="10" r="4" fill="#0052B5" />
    <path
      d="M10 6A2 2 0 0 1 10 10A2 2 0 0 0 10 14A4 4 0 0 0 10 6Z"
      fill="#D90026"
    />
    {/* Trigrams */}
    <g transform="rotate(-45 6.11 6.11)" fill="black">
      <rect x="5.01" y="4.985" width="2.2" height="0.45" />
      <rect x="5.01" y="5.885" width="2.2" height="0.45" />
      <rect x="5.01" y="6.785" width="2.2" height="0.45" />
    </g>
    <g transform="rotate(45 13.89 6.11)" fill="black">
      <rect x="12.79" y="4.985" width="0.85" height="0.45" />
      <rect x="14.14" y="4.985" width="0.85" height="0.45" />
      <rect x="12.79" y="5.885" width="2.2" height="0.45" />
      <rect x="12.79" y="6.785" width="0.85" height="0.45" />
      <rect x="14.14" y="6.785" width="0.85" height="0.45" />
    </g>
    <g transform="rotate(45 6.11 13.89)" fill="black">
      <rect x="5.01" y="12.765" width="2.2" height="0.45" />
      <rect x="5.01" y="13.665" width="0.85" height="0.45" />
      <rect x="6.36" y="13.665" width="0.85" height="0.45" />
      <rect x="5.01" y="14.565" width="2.2" height="0.45" />
    </g>
    <g transform="rotate(-45 13.89 13.89)" fill="black">
      <rect x="12.79" y="12.765" width="0.85" height="0.45" />
      <rect x="14.14" y="12.765" width="0.85" height="0.45" />
      <rect x="12.79" y="13.665" width="0.85" height="0.45" />
      <rect x="14.14" y="13.665" width="0.85" height="0.45" />
      <rect x="12.79" y="14.565" width="0.85" height="0.45" />
      <rect x="14.14" y="14.565" width="0.85" height="0.45" />
    </g>
  </>
);

KOFlagArt.displayName = 'KOFlagArt';
